import { Renewal } from "pmt-types/src/models/Renewal.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationGenerateRenewalLink = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (renewal: Renewal) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/renewals/${renewal.id}/link`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to generate renewal link");
      }

      return (await response.json()) as { url: string };
    },
    {
      onError: (error, data) => {
        console.error("Failed to generate renewal link", error, data);
      },
    },
  );
};
